import Vue from "vue";
import Router from "vue-router";
import lazyLoading from "./lazyLoading";
Vue.use(Router);

const appRouters = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index"),
    meta: {
      title: "请先登录",
      isFullScreen: true,
    },
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import("@/views/login/auth"),
    meta: {
      title: "登录中",
      isFullScreen: true,
    },
  },

  {
    path: "/accountlogin",
    name: "accountlogin",
    component: () => import("@/views/login/account"),
    meta: {
      title: "账号密码登录",
      isFullScreen: true,
    },
  },
  {
    path: "/bindphone",
    name: "bindphone",
    component: () => import("@/views/login/bindPhone"),
    meta: {
      title: "绑定手机号",
      isFullScreen: true,
    },
  },

  {
    path: "/profile",
    name: "profile",
    component: () => import("@/views/profile/index"),
    meta: {
      title: "我的",
      hasTabbar: true,
      // hasHeader: false,
      hasAuth: true,
    },
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("@/views/profile/setting"),
    meta: {
      title: "个人信息",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },
  {
    path: "/updateprofile",
    name: "updateprofile",
    component: () => import("@/views/profile/updateprofile"),
    meta: {
      title: "修改个人信息",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },
  {
    path: "/updatemobile",
    name: "updatemobile",
    component: () => import("@/views/profile/updatemobile"),
    meta: {
      title: "修改手机号",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },
  {
    path: "/updatepass",
    name: "updatepass",
    component: () => import("@/views/profile/updatepass"),
    meta: {
      title: "修改密码",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },

  {
    path: "/orderdetail",
    name: "orderdetail",
    // redirect:'/order?type=1',
    component: () => import("@/views/order/detail"),
    meta: {
      title: "订单详情",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },
  {
    path: "/subOrdersList",
    name: "subOrdersList",
    // redirect:'/order?type=1',
    component: () => import("@/views/order/subOrdersList"),
    meta: {
      title: "分寄列表",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },

  {
    path: "/logic",
    name: "logic",
    component: () => import("@/views/logic/logic-page"),
    meta: {
      title: "邮发查询",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },
  {
    path: "/logicdetail",
    name: "logicdetail",
    component: () => import("@/views/logic/detail"),
    meta: {
      title: "邮发详情",
      hasTabbar: false,
      hasHeader: false,
      hasAuth: true,
    },
  },
  {
    path: "/unit",
    name: "unit",
    component: () => import("@/views/buy/addresslist"),
    meta: {
      title: "收件信息查询",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
      // rightText: "新增",
      rightTo: "/profile",
    },
  },
  {
    path: "/unitadd",
    name: "unitadd",
    component: () => import("@/views/buy/addressupdate"),
    meta: {
      title: "订阅单位",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },
  // {
  //   path: "/unitupdate",
  //   name: "unitupdate",
  //   component: () => import("@/views/unit/update"),
  //   meta: {
  //     title: "修改订阅单位",
  //     hasTabbar: false,
  //     hasHeader: false,
  //     hasAuth: true,
  //   },
  // },
  // {
  //   path: "/unitdetail",
  //   name: "unitdetail",
  //   component: () => import("@/views/unit/detail"),
  //   meta: {
  //     title: "订阅单位详情",
  //     hasTabbar: false,
  //     hasHeader: false,
  //     hasAuth: true,
  //     // rightText:'删除',
  //     // rightEvent: 'deleteUnit'
  //   },
  // },

  {
    path: "/order",
    name: "order",
    // redirect:'/order?type=1',
    component: () => import("@/views/order/index"),
    meta: {
      title: "我的订单",
      hasTabbar: true,
      hasHeader: false,
      hasAuth: true,
      noBackBtn: true,
    },
  },
  {
    path: "/orders",
    name: "orders",
    component: () => import("@/views/order/orders"),
    meta: {
      title: "订单",
      hasTabbar: true,
      hasHeader: false,
      hasAuth: true,
      noBackBtn: true,
    },
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/buy/index"),
    meta: {
      title: "首页",
      hasTabbar: true,
      hasHeader: false,
      hasAuth: true,
      noBackBtn: true,
    },
  },
  {
    path: "/subscribe",
    name: "subscribe",
    component: () => import("@/views/buy/subscribe"),
    meta: {
      title: "书刊",
      hasTabbar: true,
      hasHeader: false,
      hasAuth: true,
      noBackBtn: true,
    },
  },
  {
    path: "/bannerDetail",
    name: "bannerDetail",
    component: () => import("@/views/buy/bannerDetail"),
    meta: {
      title: "图文详情",
      hasTabbar: true,
      hasHeader: false,
      hasAuth: true,
      noBackBtn: true,
    },
  },
  {
    path: "/call",
    name: "call",
    component: () => import("@/views/buy/call"),
    meta: {
      title: "客服",
      hasTabbar: true,
      hasHeader: false,
      hasAuth: true,
      noBackBtn: true,
    },
  },
  {
    path: "/buydetail",
    name: "buydetail",
    component: () => import("@/views/buy/detail"),
    meta: {
      title: "确认订单",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },
  {
    path: "/zhpay",
    name: "pay",
    component: () => import("@/views/buy/pay"),
    meta: {
      title: "支付订单",
      hasTabbar: false,
      hasHeader: false,
      hasAuth: true,
    },
  },
  {
    path: "/paysuccess",
    name: "pay",
    component: () => import("@/views/buy/paysuccess"),
    meta: {
      title: "订阅成功",
      hasTabbar: false,
      hasHeader: false,
      hasAuth: true,
    },
  },
  {
    path: "/paysuccess_iframe",
    name: "pay",
    component: () => import("@/views/buy/paysuccess_iframe"),
    meta: {
      title: "订阅成功",
      hasTabbar: false,
      hasHeader: false,
      hasAuth: true,
    },
  },

  {
    path: "/paysubscribe",
    name: "pay",
    component: () => import("@/views/buy/paysubscribe"),
    meta: {
      title: "订阅成功",
      hasTabbar: false,
      hasHeader: false,
      hasAuth: true,
    },
  },
  {
    path: "/payfail",
    name: "pay",
    component: () => import("@/views/buy/payfail"),
    meta: {
      title: "订阅失败",
      hasTabbar: false,
      hasHeader: false,
      hasAuth: true,
    },
  },
  {
    path: "/update",
    name: "update",
    component: () => import("@/views/order/update"),
    meta: {
      title: "期刊修改",
      hasTabbar: false,
      hasHeader: false,
      hasAuth: true,
    },
  },
  {
    path: "/fapiao",
    name: "fapiao",
    component: () => import("@/views/buy/fapiao"),
    meta: {
      title: "选择发票",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
      // rightText:'常用发票地址',
      // rightTo:'/commfapiao'
    },
  },
  {
    path: "/invoice",
    name: "invoice",
    component: () => import("@/views/buy/invoice/index"),
    meta: {
      title: "选择发票",
      hasTabbar: false,
      isFullScreen: true,
      hasHeader: true,
      hasAuth: true
    },
  },
  {
    path: "/invoiceadd",
    name: "invoiceadd",
    component: () => import("@/views/buy/invoice/add"),
    meta: {
      title: "添加发票",
      hasTabbar: false,
      hasHeader: true,
      isFullScreen: true,
      hasAuth: true
    },
  },
  {
    path: "/invoiceadd2",
    name: "invoiceadd2",
    component: () => import("@/views/buy/invoice/add"),
    meta: {
      title: "添加发票",
      hasTabbar: false,
      hasHeader: true,
      isFullScreen: true,
      hasAuth: true
    },
  },
  {
    path: "/invoicelist",
    name: "invoicelist",
    component: () => import("@/views/buy/invoice/list"),
    meta: {
      title: "发票列表",
      hasTabbar: false,
      hasHeader: true,
      isFullScreen: true,
      hasAuth: true
    },
  },
  {
    path: "/invoicelist2",
    name: "invoicelist2",
    component: () => import("@/views/buy/invoice/list"),
    meta: {
      title: "开票信息查询",
      hasTabbar: false,
      hasHeader: true,
      isFullScreen: true,
      hasAuth: true,
      rightTo: '/profile'
    },
  },
  {
    path: "/paymentInformation",
    name: "paymentInformation",
    component: () => import("@/views/buy/paymentInformation"),
    meta: {
      title: "单位汇款信息",
      hasTabbar: false,
      hasHeader: true,
      isFullScreen: true,
      hasAuth: true,
      rightTo: '/profile'
    },
  },
  // {
  //   path: "/commfapiao",
  //   name: "commfapiao",
  //   component: () => import("@/views/buy/commfapiao"),
  //   meta: {
  //     title: "常用发票地址",
  //     hasTabbar: false,
  //     hasHeader: false,
  //     hasAuth: true,
  //   },
  // },
  // {
  //   path: "/kaipiao",
  //   name: "kaipiao",
  //   component: () => import("@/views/order/kaipiao"),
  //   meta: {
  //     title: "开票申请",
  //     hasTabbar: false,
  //     hasHeader: false,
  //     hasAuth: true,
  //   },
  // },
  {
    path: "/addresslist",
    name: "addresslist",
    component: () => import("@/views/buy/addresslist"),
    meta: {
      title: "收货信息",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },
  {
    path: "/addressupdate",
    name: "addressupdate",
    component: () => import("@/views/buy/addressupdate"),
    meta: {
      title: "编辑收货信息",
      hasTabbar: false,
      hasHeader: true,
      hasAuth: true,
    },
  },



  // {
  //   path: '/404',
  //   name: '404',
  //   title: '404未找到',
  //   component: () => import('@/views/error/404'),
  //   meta: {
  //     name: '404',
  //     title: '404未找到',
  //     show: 0,
  //     requiresAuth: false,
  //     isTab: false,
  //   }
  // },
  // {
  //   path: '*',
  //   redirect: {
  //     name: '404'
  //   }
  // }
];

// appRouters.push(...sRouters);

export default new Router({
  mode: "history",
  linkActiveClass: "link-active",
  base: process.env.BASE_URL,
  routes: appRouters, //默认只有登陆
});



// WEBPACK FOOTER //
// ./src/router/index.js